import { defineComponent, h, watch, reactive } from 'vue';
import { col, cols } from '@/ui/components';
import { inputField } from '@/ui/components/form';
import { parseInt10 } from '@/ui/helpers';
import { emptyDueAfter } from '@/ui/DTO';
import { VNodeData } from 'vue/types/vnode.d';
import { t } from '@/ui/i18n/i18n';
import { DueAfter } from '@/entities/issueTemplate';

interface DueAfterSelectionProps {
  value: DueAfter | null;
}

export const DueAfterSelection = defineComponent({
  name: 'DueAfterSelection',
  props: ['value'],
  setup(props, context) {
    const duration = reactive(props.value ?? emptyDueAfter());

    const onDurationInput = (key: keyof DueAfter) => {
      return (value: string | null) => {
        if (value) {
          duration[key] = parseInt10(value);
        } else {
          duration[key] = null;
        }
      };
    };

    const onDurationChange = (d: DueAfter) => context.emit('input', d);

    watch(duration, onDurationChange);
    watch(() => props.value, newDuration => {
      duration.weeks = newDuration?.weeks ?? null;
      duration.days = newDuration?.days ?? null;
      duration.hours = newDuration?.hours ?? null;
      duration.minutes = newDuration?.minutes ?? null;
    });

    return function render() {
      return cols([
        col([
          inputField({
            value: duration.weeks ? duration.weeks.toString() : '',
            label: t('issue-template.due-after.weeks'),
            name: 'weeks',
            required: false,
            placeholder: t('issue-template.due-after.weeks'),
            disabled: false,
          }, onDurationInput('weeks')),
        ], false, 'is-3'),
        col([
          inputField({
            value: duration.days ? duration.days.toString() : '',
            label: t('issue-template.due-after.days'),
            name: 'days',
            required: false,
            placeholder: t('issue-template.due-after.days'),
            disabled: false,
          }, onDurationInput('days')),
        ], false, 'is-3'),
        col([
          inputField({
            value: duration.hours ? duration.hours.toString() : '',
            label: t('issue-template.due-after.hours'),
            name: 'hours',
            required: false,
            placeholder: t('issue-template.due-after.hours'),
            disabled: false,
          }, onDurationInput('hours')),
        ], false, 'is-3'),
        col([
          inputField({
            value: duration.minutes ? duration.minutes.toString() : '',
            label: t('issue-template.due-after.minutes'),
            name: 'minutes',
            required: false,
            placeholder: t('issue-template.due-after.minutes'),
            disabled: false,
          }, onDurationInput('minutes')),
        ], false, 'is-3'),
      ], 'checklist-builder__create-action-due-after-duration-row');
    };
  },
});

export function dueAfterSelection(data: VNodeData & { props: DueAfterSelectionProps }) {
  return h(DueAfterSelection, data);
}
